<div class="card m-2" *ngIf="!loadingInit">

    <app-dynamic-form #myform23 *ngIf="regConfig5.length>0" [options]="form2Opts" [fields]="regConfig5" (submit)="submit2($event)"
        (onSwitchChange)="switchChange($event)" (onCheckboxChange)="checkbocChange($event)">
      </app-dynamic-form>

</div>

<div class="rounded-2xl p-2 bg-primary-500/50 m-2" *ngIf="loadingInit">
    <h1>CHECKING IF YOU ARE AUTHORIZED 💀💀💀💀💀💀💀💀💀</h1>
</div>

<div class="rounded-2xl p-2 bg-primary-500/50 m-2" *ngIf="showErr">
  <h1>YOU MOFO YOU CAN'T SEE THE PRIVATE SHIT IN HERE</h1>
  <h1>☠️☠️☠️☠️☠️☠️☠️☠️☠️🫨🫨🫨🫨😱😱😱😱😱😱😱☠️☠️☠️☠️☠️☠️☠️☠️☠️</h1>
  <h1>💀💀💀💀💀💀💀💀💀💀💀😿😿😿😿😿😿😿😿😿😿😿</h1>
</div>

